import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      [class]="'bg-white rounded-xl border overflow-hidden transition-shadow ' + className"
      [class.hover:shadow-lg]="hoverable"
    >
      <!-- Header -->
      <div *ngIf="header" [class]="'p-6 ' + headerClass">
        <ng-content select="[card-header]"></ng-content>
      </div>

      <!-- Body -->
      <div [class]="'p-6 ' + bodyClass">
        <ng-content></ng-content>
      </div>

      <!-- Footer -->
      <div *ngIf="footer" [class]="'p-6 border-t border-gray-200 ' + footerClass">
        <ng-content select="[card-footer]"></ng-content>
      </div>
    </div>
  `
})
export class CardComponent {
  @Input() className: string = '';
  @Input() header: boolean = false;
  @Input() footer: boolean = false;
  @Input() hoverable: boolean = false;
  @Input() headerClass: string = '';
  @Input() bodyClass: string = '';
  @Input() footerClass: string = '';
}
